import { OpportunityOperationWorkstationModel } from "./opportunity-operation-workstation.model";

export class OpportunityOperationsModel {
    operationId: string;
	actualSpentTimePerGmt: number[]; // hour wise : total_spent_time / garments completed SORT by hour
    operationDesc: string;
    workstationsInfo: OpportunityOperationWorkstationModel[];

    constructor(operationId: string,
        actualSpentTimePerGmt: number[],
        operationDesc: string,
        workstationsInfo: OpportunityOperationWorkstationModel[]){
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.actualSpentTimePerGmt = actualSpentTimePerGmt;
            this.workstationsInfo = workstationsInfo;
    }
}